import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  SparePartSupplier,
} from '@savgroup-front-common/types';

import { buildUrl, prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.sparePart}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/suppliers`;

export interface GetSparePartSuppliersQueryArgs {
  sellerId: string;
  includeMaster?: boolean;
}

export const getSparePartSuppliersRequest = ({
  sellerId,
  includeMaster,
}: GetSparePartSuppliersQueryArgs): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId), {
    includeMaster,
  }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSparePartSuppliersQuery = async ({
  sellerId,
  includeMaster = false,
}: GetSparePartSuppliersQueryArgs): Promise<
  BackResponse<SparePartSupplier[]> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<SparePartSupplier[]>>(
      getSparePartSuppliersRequest({ sellerId, includeMaster }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
